import { withChartLayout } from 'components/common';
import FLACCScale from 'components/features/chart/special-charts/flacc-scale/FLACCScale';

const FLACCScalePage = withChartLayout('FLACC Scale')(FLACCScale);
export default FLACCScalePage;
